import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

// initial state
const state = {
  categoryList: [],
  categoryListExcludingSelectedCategory: [],
  selectedCategory: null,
  uomList: [],
  categoryGroupsList: [],
  selectedUom: null,
  selectedCategoryGroups: null,
  templatesList: [],
  selectedTemplate: null,
  typeList: ['text', 'numeric', 'numeric-scale', 'numeric-array', 'boolean'],
};

export default {
  state,
  getters,
  actions,
  mutations,
};
